// extracted by mini-css-extract-plugin
module.exports = {"root":"feature-grid-card_root__157jO","seperator":"feature-grid-card_seperator__1ENx0"};